<template>
  <div
    v-if="isJoinVoip"
    :class="{ active: isVoipName }"
    class="voip-tips"
  >
    <!-- <template v-if="isVoipName"
      >
      <span class="voip-name">{{ isVoipName }}</span
      >{{$t('tips.正在连麦中')}}</template
    > -->
    <template v-if="!isVoipName">{{$t('tips.连麦功能已开启')}}</template>
  </div>
</template>

<script>
import {
  pushRoomMessageFunc,
  removeMessageFunc,
} from "@/utils/socketMessageDispose";
export default {
  computed: {
    voipInfo() {
      return this.$store.getters.voipInfo;
    },
    isJoinVoip() {
      return this.voipInfo && this.voipInfo.isJoinVoip == 0;
    },
    // 连麦用户名
    isVoipName() {
      return this.$store.getters.isVoipName;
    }
  },
  mounted() {
    pushRoomMessageFunc(this.getCvMcRoomMessage);
  },
  beforeDestroy() {
    removeMessageFunc(this.getCvMcRoomMessage);
  },
  methods: {
    getCvMcRoomMessage(msg) {
      switch (msg.cmd) {
        case 7107: {
          this.disposeCustomMessage_7107(msg.requestData);
          break;
        }
      }
    },
    disposeCustomMessage_7107(requestData) {
      switch (requestData.event) {
        case "voIPReplyOwner":
          this.$store.commit("SET_VOIP_INFO_NAME", requestData.name)
          break;
        case "voIpReplyAside":
          this.$store.commit("SET_VOIP_INFO_NAME", "")
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.voip-tips {
  position: absolute;
  bottom: 180px;
  left: 0;
  z-index: 99;
  min-width: 146px;
  height: 30px;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #fff;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 0px 15px 15px 0px;
  padding-right: 17px;

  .voip-name {
    display: inline-block;
    max-width: 60px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #6CD786;
  }

  &::before {
    content: "";
    width: 6px;
    height: 6px;
    margin: 0 10px 0 20px;
    display: block;
    background: #FF9C12;
    border-radius: 6px;
  }

  &.active::before {
    background: #6CD786;
  }
}
</style>
